import { Typography } from '@mui/material';

import { COLORS } from '~/styles/colors';

const TITLE_POSITION_MAP = {
  CENTERED: 'center',
  RIGHT: 'right',
  LEFT: 'left',
};

/**
 * @param {string}  name
 * @param {string}  surName
 * @param {string}  titleValue
 * @param {string}  titlePosition
 * @param {string}  title
 * @param {string} text
 * @param {string?} color
 * @returns {JSX.Element}
 */
export default function VCardPreviewTitleAndBodyTexts({
  name,
  surName,
  titleValue,
  titlePosition,
  title,
  text,
  color = COLORS.white,
}) {
  return (
    <>
      <Typography
        sx={{
          fontFamily: title,
          fontSize: 15,
          mt: 2,
          mb: 2,
          textAlign: TITLE_POSITION_MAP[titlePosition],
          wordBreak: 'break-word',
          color,
        }}
      >
        {name} {surName}
      </Typography>
      <Typography
        sx={{
          fontFamily: text,
          fontSize: 9,
          mb: 2,
          textAlign: TITLE_POSITION_MAP[titlePosition],
          wordBreak: 'break-word',
          color,
        }}
      >
        {titleValue}
      </Typography>
    </>
  );
}
